__turbopack_context__.v({
  "placeholder": "styles-module__v5e0mW__placeholder",
  "root": "styles-module__v5e0mW__root",
});
